import React from 'react';
import PropTypes from 'prop-types';
import Link from './link';
import { getContentfulPageWithPath } from '../contentful/page-lookup';

const LinkPage = ({
  children, targetId, ...other
}) => {
  const page = getContentfulPageWithPath(targetId);

  // return the first path available
  if (page && page.length > 0) {
    return (
      <Link to={page[0].path} {...other}>
        {children}
      </Link>
    );
  }
  // if the page can't be found get rid of the <a> tag but keep the content within
  return children;
};

LinkPage.propTypes = {
  targetId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default LinkPage;
